import IContent from '@episerver/spa-core/dist/Models/IContent';
import { getDescription } from '../Utils';
import { Helmet } from '@dr.pogodin/react-helmet';
import { General, TU, useTranslation } from 'app/hooks/useTranslations';
import IEpiserverContext from '@episerver/spa-core/dist/Core/IEpiserverContext';
import { LanguageTag } from 'app/Models/Constants/LanguageTypes';

type HelmetAndMetaDataProps = {
    iContent: IContent;
    heading: string;
    context?: IEpiserverContext;
};

export const HelmetAndMetaData = ({ iContent, heading, context }: HelmetAndMetaDataProps) => {
    const { t } = useTranslation();
    const isTilsynsutvalget = typeof window !== 'undefined' && window.location?.host?.includes('tilsynsutvalget');

    const baseKey = isTilsynsutvalget ? TU : General;
    const titleKey = isTilsynsutvalget ? 'TilsynsutvalgetDefaultTitle' : 'NorwegianCourts';

    const translatedTitle = t(`${baseKey}.${titleKey}`, iContent.language.name);
    const pageTitle = `${heading || iContent.name}${translatedTitle ? ` | ${translatedTitle}` : ''}`;
    const description = getDescription(iContent);
    const contentId = iContent.contentLink?.id?.toString() || '';
    const currentUrl = iContent.url || (typeof window !== 'undefined' ? window.location.href : '');

    const MetaTags = (
        <>
            <title>{pageTitle}</title>
            <meta property="og:url" content={currentUrl} />
            <meta name="pageid" content={contentId} />
            <meta property="og:title" content={heading || iContent?.name?.toString()} />
            <meta property="og:description" content={description} />
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content={iContent?.language?.name ?? LanguageTag.NORWEGIAN} />
        </>
    );

    return context?.isServerSideRendering() ? <Helmet>{MetaTags}</Helmet> : MetaTags;
};

export default HelmetAndMetaData;
